import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { PORCENTAJEIVASERVICIOS, IPorcentajeRetIvaServicesPagingRes, UseMutationsParams, AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { getUrlParamsFetch, handleAxiosError } from '@/shared';

const { get, post, put } = erpApi();

///* tanSctack query
export const useFetchPorcentajeIvaServicios = ({
  page = 1,
  page_size = 10,
  codigo = '',
}: GetPorcentajeIvaServiciosParams) => {
  return useQuery({
    queryKey: ['porcentaje-iva-servicios', page, codigo, page_size],
    queryFn: async () => {
      return getPorcentajeIvaServicios({ page,codigo, page_size });
    },
  });
};

export const useGetPorcentajeIvaServicio = (id: string) => {
  return useQuery({
    queryKey: ['porcentaje-iva-servicios', id],
    queryFn: async () => {
      return getPorcentajeIva(id);
    },
  });
};

export const useCreatePorcentajeIvaServicios = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createPorcentajeIva,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['porcentaje-iva'] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Porcentaje retencion servicio creado correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdatePorcentajeIvaServicios = ({
  navigate,

  enableRedirect = true,
  returnUrl,

  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,

  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: updatePorcentajeIvaServicios,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zones'] });
      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Zona actualizada correctamente',
          AlertSeverityEnum.success
        );
    },
    onError: error => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? (returnUrl || ''));

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

///* axios
export type GetPorcentajeIvaServiciosParams = {
  page?: number;
  page_size?: number;
  codigo?: string;
};

export type CreatePorcentajeIvaServiciosParams = Omit<PORCENTAJEIVASERVICIOS, 'id_porcentaje_ret_iva_servicios'>;
export type UpdatePorcentajeIvaServiciosParams = {
  id: string;
  data: CreatePorcentajeIvaServiciosParams;
};

export const getPorcentajeIvaServicios = async (params?: GetPorcentajeIvaServiciosParams) => {
  const queryParams = getUrlParamsFetch({ ...params });
  return get<IPorcentajeRetIvaServicesPagingRes>(
    `${urlBackend}api/v1/porcentaje-ret-iva-servicios/?${queryParams}`,
    true
  );
};

export const getPorcentajeIva = async (id: string) => {
  try{
    return await get<PORCENTAJEIVASERVICIOS>(`${urlBackend}api/v1/porcentaje-ret-iva-servicios/${id}/`, true);
  }
  catch(error){
    return handleAxiosError(error);
  }
};

export const createPorcentajeIva = async (data: CreatePorcentajeIvaServiciosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await post<PORCENTAJEIVASERVICIOS>(`${urlBackend}api/v1/porcentaje-ret-iva-servicios/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};

export const updatePorcentajeIvaServicios = async ({ id, data }: UpdatePorcentajeIvaServiciosParams) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await put<PORCENTAJEIVASERVICIOS>(`${urlBackend}api/v1/porcentaje-ret-iva-servicios/${id}/`, data, true);

  setAlert(true, res.message, res.status);
  return res;
};
